import { AddressSearchOperation } from './address-search-operation.interface';

export interface AddressSearch {
  operation: AddressSearchOperation;
  id?: string;
  fragment?: string;
  requester: string;
}
